import React from "react";
import { useFormContext, Controller } from "react-hook-form";
import { Form, Input, Select, Row, Col, Divider } from "antd";

const { Option } = Select;

const Step2ContactDetails = () => {
    const {
        control,
        formState: { errors },
    } = useFormContext();


    const countryList = [
        "Afghanistan",
        "Åland Islands",
        "Albania",
        "Algeria",
        "American Samoa",
        "Andorra",
        "Angola",
        "Anguilla",
        "Antarctica",
        "Antigua and Barbuda",
        "Argentina",
        "Armenia",
        "Aruba",
        "Australia",
        "Austria",
        "Azerbaijan",
        "Bahamas",
        "Bahrain",
        "Bangladesh",
        "Barbados",
        "Belarus",
        "Belgium",
        "Belize",
        "Benin",
        "Bermuda",
        "Bhutan",
        "Bolivia",
        "Bosnia and Herzegovina",
        "Botswana",
        "Bouvet Island",
        "Brazil",
        "British Indian Ocean Territory",
        "Brunei Darussalam",
        "Bulgaria",
        "Burkina Faso",
        "Burundi",
        "Cambodia",
        "Cameroon",
        "Canada",
        "Cape Verde",
        "Cayman Islands",
        "Central African Republic",
        "Chad",
        "Chile",
        "China",
        "Christmas Island",
        "Cocos (Keeling) Islands",
        "Colombia",
        "Comoros",
        "Congo",
        "Congo, The Democratic Republic of The",
        "Cook Islands",
        "Costa Rica",
        "Cote D'ivoire",
        "Croatia",
        "Cuba",
        "Curaçao",
        "Cyprus",
        "Czech Republic",
        "Denmark",
        "Djibouti",
        "Dominica",
        "Dominican Republic",
        "Ecuador",
        "Egypt",
        "El Salvador",
        "Equatorial Guinea",
        "Eritrea",
        "Estonia",
        "Ethiopia",
        "Falkland Islands (Malvinas)",
        "Faroe Islands",
        "Fiji",
        "Finland",
        "France",
        "French Guiana",
        "French Polynesia",
        "French Southern Territories",
        "Gabon",
        "Gambia",
        "Georgia",
        "Germany",
        "Ghana",
        "Gibraltar",
        "Greece",
        "Greenland",
        "Grenada",
        "Guadeloupe",
        "Guam",
        "Guatemala",
        "Guernsey",
        "Guinea",
        "Guinea-bissau",
        "Guyana",
        "Haiti",
        "Heard Island and Mcdonald Islands",
        "Holy See (Vatican City State)",
        "Honduras",
        "Hong Kong",
        "Hungary",
        "Iceland",
        "India",
        "Indonesia",
        "Iran, Islamic Republic of",
        "Iraq",
        "Ireland",
        "Isle of Man",
        "Israel",
        "Italy",
        "Jamaica",
        "Japan",
        "Jersey",
        "Jordan",
        "Kazakhstan",
        "Kenya",
        "Kiribati",
        "Korea, Democratic People's Republic of",
        "Korea, Republic of",
        "Kuwait",
        "Kyrgyzstan",
        "Lao People's Democratic Republic",
        "Latvia",
        "Lebanon",
        "Lesotho",
        "Liberia",
        "Libyan Arab Jamahiriya",
        "Liechtenstein",
        "Lithuania",
        "Luxembourg",
        "Macao",
        "Macedonia, The Former Yugoslav Republic of",
        "Madagascar",
        "Malawi",
        "Malaysia",
        "Maldives",
        "Mali",
        "Malta",
        "Marshall Islands",
        "Martinique",
        "Mauritania",
        "Mauritius",
        "Mayotte",
        "Mexico",
        "Micronesia, Federated States of",
        "Moldova, Republic of",
        "Monaco",
        "Mongolia",
        "Montenegro",
        "Montserrat",
        "Morocco",
        "Mozambique",
        "Myanmar",
        "Namibia",
        "Nauru",
        "Nepal",
        "Netherlands",
        "New Caledonia",
        "New Zealand",
        "Nicaragua",
        "Niger",
        "Nigeria",
        "Niue",
        "Norfolk Island",
        "Northern Mariana Islands",
        "Norway",
        "Oman",
        "Pakistan",
        "Palau",
        "Palestinian Territory, Occupied",
        "Panama",
        "Papua New Guinea",
        "Paraguay",
        "Peru",
        "Philippines",
        "Pitcairn",
        "Poland",
        "Portugal",
        "Puerto Rico",
        "Qatar",
        "Reunion",
        "Romania",
        "Russia",
        "Rwanda",
        "Saint Helena",
        "Saint Kitts and Nevis",
        "Saint Lucia",
        "Saint Pierre and Miquelon",
        "Saint Vincent and The Grenadines",
        "Samoa",
        "San Marino",
        "Sao Tome and Principe",
        "Saudi Arabia",
        "Senegal",
        "Serbia",
        "Seychelles",
        "Sierra Leone",
        "Singapore",
        "Slovakia",
        "Slovenia",
        "Solomon Islands",
        "Somalia",
        "South Africa",
        "South Georgia and The South Sandwich Islands",
        "Spain",
        "Sri Lanka",
        "Sudan",
        "Suriname",
        "Svalbard and Jan Mayen",
        "Eswatini",
        "Sweden",
        "Switzerland",
        "Syrian Arab Republic",
        "Taiwan (ROC)",
        "Tajikistan",
        "Tanzania",
        "Thailand",
        "Timor-leste",
        "Togo",
        "Tokelau",
        "Tonga",
        "Trinidad and Tobago",
        "Tunisia",
        "Turkey",
        "Turkmenistan",
        "Turks and Caicos Islands",
        "Tuvalu",
        "Uganda",
        "Ukraine",
        "United Arab Emirates",
        "United Kingdom",
        "United States",
        "United States Minor Outlying Islands",
        "Uruguay",
        "Uzbekistan",
        "Vanuatu",
        "Venezuela",
        "Vietnam",
        "Virgin Islands, British",
        "Virgin Islands, U.S.",
        "Wallis and Futuna",
        "Western Sahara",
        "Yemen",
        "Zambia",
        "Zimbabwe",
    ];


    return (
        <div style={{ background: "#fff", padding: 25, borderRadius: 8 }}>
            <h4 style={{ marginBottom: 20, fontWeight: 600 }}>General Information</h4>

            <Form layout="vertical">
                <Row gutter={24}>
                    <Col span={12}>
                        <Form.Item label="Relationship / Liaison Manager">
                            <Controller
                                name="liaisonManager"
                                control={control}
                                render={({ field }) => (
                                    <Input placeholder="Enter" {...field} />
                                )}
                            />
                        </Form.Item>

                        <Form.Item label="Relationship / Liaison Manager’s Role">
                            <Controller
                                name="liaisonManagerRole"
                                control={control}
                                render={({ field }) => (
                                    <Input placeholder="Enter" {...field} />
                                )}
                            />
                        </Form.Item>

                        <Form.Item label="Other Side entity name / Alias name">
                            <Controller
                                name="aliasName"
                                control={control}
                                render={({ field }) => (
                                    <Input placeholder="Enter" {...field} />
                                )}
                            />
                        </Form.Item>

                        <Form.Item label="Classification Type">
                            <Controller
                                name="classificationType"
                                control={control}
                                render={({ field }) => (
                                    <Input placeholder="Enter" {...field} />
                                )}
                            />
                        </Form.Item>

                        <Form.Item label="Secretory">
                            <Controller
                                name="secretory"
                                control={control}
                                render={({ field }) => (
                                    <Input placeholder="Enter" {...field} />
                                )}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item label="Relationship / Liaison Manager’s Email">
                            <Controller
                                name="liaisonEmail"
                                control={control}
                                rules={{
                                    pattern: {
                                        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                        message: "Enter a valid email address",
                                    },
                                }}
                                render={({ field }) => (
                                    <Input
                                        {...field}
                                        placeholder="Enter email"
                                        onChange={(e) =>
                                            field.onChange(e.target.value.toLowerCase())
                                        }
                                    />
                                )}
                            />
                        </Form.Item>


                        <Form.Item label="Relationship / Liaison Manager’s ID">
                            <Controller
                                name="liaisonId"
                                control={control}
                                render={({ field }) => (
                                    <Input placeholder="Enter" {...field} />
                                )}
                            />
                        </Form.Item>

                        <Form.Item label="Entity Type">
                            <Controller
                                name="entityType"
                                control={control}
                                render={({ field }) => (
                                    <Input placeholder="Private Corporation / Family Owned / Public etc" {...field} />
                                )}
                            />
                        </Form.Item>

                        <Form.Item label="Principle Lawyer">
                            <Controller
                                name="principleLawyer"
                                control={control}
                                render={({ field }) => (
                                    <Input placeholder="Enter" {...field} />
                                )}
                            />
                        </Form.Item>

                        <Form.Item label="Principle Banker">
                            <Controller
                                name="principleBanker"
                                control={control}
                                render={({ field }) => (
                                    <Input placeholder="Enter" {...field} />
                                )}
                            />
                        </Form.Item>
                    </Col>
                </Row>

                {/* -------------------------------- OTHER INFORMATION -------------------------------- */}
                <Divider style={{ margin: "30px 0 20px 0" }} />

                <h4 style={{ marginBottom: 20, fontWeight: 600 }}>Other Information</h4>

                <Row gutter={24}>
                    <Col span={12}>
                        <Form.Item
                            label={<span>
                                {/* <span style={{ color: "red" }}>*</span>  */}
                                BC Client ID</span>}
                            // validateStatus={errors.bcClientId ? "error" : ""}
                            // help={errors.bcClientId?.message}
                        >
                            <Controller
                                name="bcClientId"
                                // control={control}
                                // rules={{ required: "BC Client ID is required" }}
                                render={({ field }) => <Input {...field} />}
                            />
                        </Form.Item>

                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label={<span>
                                {/* <span style={{ color: "red" }}>*</span>  */}
                                Risk Classification</span>}
                            // validateStatus={errors.riskClassification ? "error" : ""}
                            // help={errors.riskClassification?.message}
                        >
                            <Controller
                                name="riskClassification"
                                // control={control}
                                // rules={{ required: "Risk classification is required" }}
                                render={({ field }) => <Input {...field} />}
                            />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={24}>
                    <Col span={12}>
                        <Form.Item
                            label={<span>
                                {/* <span style={{ color: "red" }}>*</span>  */}
                            Review Cycle Period</span>}
                            // validateStatus={errors.reviewCyclePeriod ? "error" : ""}
                            // help={errors.reviewCyclePeriod?.message}
                        >
                            <Controller
                                name="reviewCyclePeriod"
                                // control={control}
                                // rules={{ required: "Review cycle period is required" }}
                                render={({ field }) => (
                                    <Input placeholder="Annual / Quarterly / Monthly" {...field} />
                                )}
                            />
                        </Form.Item>



                        <Form.Item
                            label={<span>
                                {/* <span style={{ color: "red" }}>*</span>  */}
                                Status</span>}
                            // validateStatus={errors.status ? "error" : ""}
                            // help={errors.status?.message}
                        >
                            <Controller
                                name="status"
                                // control={control}
                                // rules={{ required: "Status is required" }}
                                render={({ field }) => (
                                    <Select placeholder="Select" {...field}>
                                        <Option value="Active">Active</Option>
                                        <Option value="Inactive">Inactive</Option>
                                    </Select>
                                )}
                            />
                        </Form.Item>

                        <Form.Item label="Size">
                            <Controller
                                name="sizeMarketing"
                                control={control}
                                render={({ field }) => <Input placeholder="Medium / Large / Small" {...field} />}
                            />
                        </Form.Item>

                        <Form.Item label="Domicile">
                            <Controller
                                name="domicile"
                                control={control}
                                render={({ field }) => (
                                    <Select placeholder="Select" {...field}>
                                        {countryList?.map((country, index) => (
                                            <Option key={index} value={country}>
                                                {country}
                                            </Option>
                                        ))}
                                    </Select>
                                )}
                            />
                        </Form.Item>

                        <Form.Item label="Type of PIE">
                            <Controller
                                name="typeOfPIE"
                                control={control}
                                render={({ field }) => <Input placeholder="Enter" {...field} />}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item label="Review Due Date">
                            <Controller
                                name="reviewDueDate"
                                control={control}
                                render={({ field }) => (
                                    <Input type="date" {...field} />
                                )}
                            />
                        </Form.Item>

                        <Form.Item label="Country of incorporation">
                            <Controller
                                name="reviewCountryIncorp"
                                control={control}
                                render={({ field }) => (
                                    <Select placeholder="Select" {...field}>
                                        {countryList?.map((country, index) => (
                                            <Option key={index} value={country}>
                                                {country}
                                            </Option>
                                        ))}
                                    </Select>
                                )}
                            />
                        </Form.Item>

                        <Form.Item label="Public Interest Entity">
                            <Controller
                                name="publicInterestEntity"
                                control={control}
                                render={({ field }) => (
                                    <Select placeholder="Select" {...field}>
                                        <Option value="Yes">Yes</Option>
                                        <Option value="No">No</Option>
                                    </Select>
                                )}
                            />
                        </Form.Item>

                        <Form.Item label="Regulator">
                            <Controller
                                name="regulator"
                                control={control}
                                render={({ field }) => (
                                    <Select placeholder="Select" {...field}>
                                        <Option value="Yes">Yes</Option>
                                        <Option value="No">No</Option>
                                    </Select>
                                )}
                            />
                        </Form.Item>
                    </Col>
                </Row>


                {/* ---------------- MARKETING SECTION ---------------- */}
                <Divider style={{ margin: "30px 0 20px 0" }} />
                <h4 style={{ marginBottom: 20, fontWeight: 600 }}>Marketing</h4>

                <Row gutter={24}>
                    <Col span={12}>
                        <Form.Item
                            label={<span>
                                {/* <span style={{ color: "red" }}>*</span>  */}
                            Last Date Included in Campaign</span>}
                            // validateStatus={errors.lastDateCampaign ? "error" : ""}
                            // help={errors.lastDateCampaign?.message}
                        >
                            <Controller
                                name="lastDateCampaign"
                                // control={control}
                                // rules={{ required: "Last date included in campaign is required" }}
                                render={({ field }) => <Input type="date" {...field} />}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item label="Send Marketing Materials">
                            <Controller
                                name="sendMarketingMaterials"
                                control={control}
                                render={({ field }) => (
                                    <Select placeholder="Select" {...field}>
                                        <Option value="Yes">Yes</Option>
                                        <Option value="No">No</Option>
                                    </Select>
                                )}
                            />
                        </Form.Item>
                    </Col>
                </Row>
                {/* ---------------- BUSINESS RELATIONSHIP SECTION ---------------- */}
                <Divider style={{ margin: "30px 0 20px 0" }} />
                <h4 style={{ marginBottom: 20, fontWeight: 600 }}>Business Relationship</h4>

                <Row gutter={24}>
                    <Col span={12}>
                        <Form.Item
                            label={<span>
                                {/* <span style={{ color: "red" }}>*</span>  */}
                            Business Relationship</span>}
                            // validateStatus={errors.businessRelationship ? "error" : ""}
                            // help={errors.businessRelationship?.message}
                        >
                            <Controller
                                name="businessRelationship"
                                // control={control}
                                // rules={{ required: "Business relationship is required" }}
                                render={({ field }) => <Input {...field} />}
                            />
                        </Form.Item>


                        <Form.Item
                            label={<span>
                                {/* <span style={{ color: "red" }}>*</span>  */}
                                BR Flag Value</span>}
                            // validateStatus={errors.brFlagValue ? "error" : ""}
                            // help={errors.brFlagValue?.message}
                        >
                            <Controller
                                name="brFlagValue"
                                // control={control}
                                // rules={{ required: "BR Flag Value is required" }}
                                render={({ field }) => <Input {...field} />}
                            />
                        </Form.Item>


                        <Form.Item
                            label={<span>
                                {/* <span style={{ color: "red" }}>*</span>  */}
                                Designation Template</span>}
                            // validateStatus={errors.designationTemplate ? "error" : ""}
                            // help={errors.designationTemplate?.message}
                        >
                            <Controller
                                name="designationTemplate"
                                // control={control}
                                // rules={{ required: "Designation template is required" }}
                                render={({ field }) => <Input {...field} />}
                            />
                        </Form.Item>
                        <Form.Item
                            label={<span>
                                {/* <span style={{ color: "red" }}>*</span>  */}
                                Created Date</span>}
                            // validateStatus={errors.createdDate ? "error" : ""}
                            // help={errors.createdDate?.message}
                        >
                            <Controller
                                name="createdDate"
                                // control={control}
                                // rules={{ required: "Created date is required" }}
                                render={({ field }) => <Input type="date" {...field} />}
                            />
                        </Form.Item>


                        <Form.Item
                            label={<span>
                                {/* <span style={{ color: "red" }}>*</span>  */}
                            Removal / Archive Reason</span>}
                            // validateStatus={errors.archiveReason ? "error" : ""}
                            // help={errors.archiveReason?.message}
                        >
                            <Controller
                                name="archiveReason"
                                // control={control}
                                // rules={{ required: "Archive reason is required" }}
                                render={({ field }) => <Input {...field} />}
                            />
                        </Form.Item>

                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label={<span>
                                {/* <span style={{ color: "red" }}>*</span>  */}
                            Strategic Partner</span>}
                            // validateStatus={errors.strategicPartner ? "error" : ""}
                            // help={errors.strategicPartner?.message}
                        >
                            <Controller
                                name="strategicPartner"
                                // control={control}
                                // rules={{ required: "Please select Strategic Partner" }}
                                render={({ field }) => (
                                    <Select placeholder="Select" {...field}>
                                        <Option value="true">Yes</Option>
                                        <Option value="false">No</Option>
                                    </Select>
                                )}
                            />
                        </Form.Item>
                        <Form.Item
                            label={<span>
                                {/* <span style={{ color: "red" }}>*</span>  */}
                            Business Designation Type</span>}
                            // validateStatus={errors.businessDesignationType ? "error" : ""}
                            // help={errors.businessDesignationType?.message}
                        >
                            <Controller
                                name="businessDesignationType"
                                // control={control}
                                // rules={{ required: "Business designation type is required" }}
                                render={({ field }) => <Input {...field} />}
                            />
                        </Form.Item>


                        <Form.Item
                            label={<span>
                                {/* <span style={{ color: "red" }}>*</span>  */}
                            Designation Level / Location Hierarchy</span>}
                            // validateStatus={errors.designationLevel ? "error" : ""}
                            // help={errors.designationLevel?.message}
                        >
                            <Controller
                                name="designationLevel"
                                // control={control}
                                // rules={{ required: "Designation level is required" }}
                                render={({ field }) => <Input {...field} />}
                            />
                        </Form.Item>
                        <Form.Item
                            label={<span>
                                {/* <span style={{ color: "red" }}>*</span>  */}
                            Removal / Archive Date</span>}
                            // validateStatus={errors.archiveDate ? "error" : ""}
                            // help={errors.archiveDate?.message}
                        >
                            <Controller
                                name="archiveDate"
                                // control={control}
                                // rules={{ required: "Archive date is required" }}
                                render={({ field }) => <Input type="date" {...field} />}
                            />
                        </Form.Item>

                        <Form.Item label="Reference (Optional)">
                            <Controller
                                name="reference"
                                control={control}
                                render={({ field }) => <Input placeholder="Enter reference" {...field} />}
                            />
                        </Form.Item>
                    </Col>
                </Row>


            </Form>
        </div>
    );
};

export default Step2ContactDetails;
